if (!customElements.get('product-bottom-tabs')) {
  class ProductBottomTabs extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const links = this.querySelectorAll('.tab-link');
      const panels = this.querySelectorAll('.tab-panel');

      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('aria-controls');
          const targetPanel = this.querySelector(`#${targetId}`);

          // Deactivate all
          links.forEach(l => {
            l.classList.remove('active');
            l.setAttribute('aria-selected', 'false');
          });
          panels.forEach(p => {
            p.classList.remove('active');
            p.hidden = true;
          });

          // Activate target
          link.classList.add('active');
          link.setAttribute('aria-selected', 'true');
          if (targetPanel) {
            targetPanel.classList.add('active');
            targetPanel.hidden = false;
          }
        });
      });
    }
  }

  customElements.define('product-bottom-tabs', ProductBottomTabs);
}

/**
 * Unboxing Video Modal — Autoplay & Scroll Lock
 * Targets all modal-dialog elements with [data-unboxing-modal].
 * On open: autoplays the video from the start, locks body scroll.
 * On close: pauses, resets playback, unlocks body scroll.
 */
(function initUnboxingVideoModals() {
  function setup() {
    var modals = document.querySelectorAll('modal-dialog[data-unboxing-modal]');

    modals.forEach(function (modal) {
      var blockId = modal.getAttribute('data-unboxing-modal');
      var video = document.getElementById('UnboxingVideo-' + blockId);

      if (!video) return;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'open') return;

          if (modal.hasAttribute('open')) {
            document.body.style.setProperty('overflow', 'hidden', 'important');
            video.muted = false;
            video.currentTime = 0;
            video.play().catch(function () {
              video.muted = true;
              video.play();
            });
          } else {
            video.pause();
            video.currentTime = 0;
            document.body.style.removeProperty('overflow');
          }
        });
      });

      observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }

  // modal-dialog moves itself to body via connectedCallback,
  // so we wait a tick after DOMContentLoaded to ensure it's in place.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(setup, 0);
    });
  } else {
    setTimeout(setup, 0);
  }
})();
